import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { AuthService } from '../services/security/auth.service';

export const organizationOnboardingGuard: CanActivateFn = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user needs organization onboarding
  const needsOrganizationOnboarding = authService.currentUser?.needs_organization_onboarding;

  if (needsOrganizationOnboarding) {
    // User needs organization onboarding - allow access
    return of(true);
  }

  // User doesn't need organization onboarding - redirect to appropriate page
  if (authService.currentUser?.subscription_status === 'active') {
    // User has active subscription - redirect to organization dashboard
    router.navigate(['/company/settings']);
  } else {
    // User doesn't have active subscription - redirect to user onboarding
    router.navigate(['/onboarding']);
  }

  return of(false);
};
